module.exports = __webpack_public_path__ + "static/img/134.7269de8.png";